// extracted by mini-css-extract-plugin
export default {"customArrows":"CarousalArrow_customArrows__VgGaD"};